import React, { useState } from "react";
import { containerStyle } from "../../styles/styles";
import { TableStyles } from "../../styles/table";
import ActiveServices from "../../uis/settings/services";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import { useHistory } from "react-router-dom";
import ServiceModal from "../../uis/modals/addService/addService";

const Services = () => {
  const classes = containerStyle();
  const tabClasses = TableStyles();
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <ServiceModal
        title="Add New Service"
        open={showModal}
        close={handleClose}
        btnText="Add Service"
      />
      <div
        style={{
          background: "#FFFFFF",
          padding: "1rem 1.5rem",
          display: "flex",
          alignItems: "center",
          borderBottom: "2px solid #E5E5E5",
          cursor: "pointer",
        }}
      >
        <img
          src="/assets/ion_arrow-back-circle.png"
          alt=""
          style={{ marginRight: "0.5rem" }}
          onClick={() => history.goBack()}
        />
        <p style={{ fontWeight: "700" }}>Back</p>
      </div>
      <div className={tabClasses.filterContainer}>
        <p>
          <LocalBarIcon /> Filter by:
        </p>
        <button
          className={tabClasses.addBtn}
          onClick={() => setShowModal(true)}
        >
          Add Services
        </button>
      </div>
      <div className={classes.main}>
        <div className={tabClasses.tableRoot}>
          <div className={tabClasses.tabPanelContainer}>
            <ActiveServices />
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;
